/**
 * Which Player you are in a given society.
 *
 * A user is a different Player in each society they belong to — different row,
 * different handicap — so "who am I here" is a lookup, not a property of the
 * user. It was written out by hand in a dozen components and NOT the same way
 * twice: some compared `s.id === societyId`, some `String(s.id) ===
 * String(societyId)`.
 *
 * That difference is not cosmetic. The id arrives as a NUMBER from the API and
 * as a STRING from anything that has been through `localStorage` or a URL, so
 * a strict comparison can silently find nothing — and a null player id reads
 * all the way down as "this user is not playing", which hides their own
 * controls from them. String comparison on both sides is the only version that
 * cannot do that.
 */
export const myPlayerIdIn = (userProfile, societyId) => {
  if (!userProfile?.societies || societyId === null || societyId === undefined) {
    return null;
  }
  const society = userProfile.societies.find(
    (s) => String(s.id) === String(societyId),
  );
  return society?.player_id ?? null;
};

/** Is this user one of the players on the given roster? */
export const isPlayerInRoster = (roster, userProfile, societyId) => {
  const myId = myPlayerIdIn(userProfile, societyId);
  if (!myId) return false;
  return (roster || []).some((p) => String(p?.id) === String(myId));
};

export default myPlayerIdIn;
